<template>
  <div>
    <vs-popup :title="$t('WriteAnswer')" :active.sync="showModal">
      <form>
        <vs-textarea
          v-model="modelName"
          name="Description"
          :label="$t('Description')"
          rows="3"
          v-show="!lastAnswer"
          disabled
        />
        <vs-textarea
          v-model="lastAnswer"
          name="Description"
          :label="$t('Description')"
          rows="3"
          v-show="lastAnswer"
          disabled
        />

        <span class="text-danger text-sm" v-show="showError">
          "{{ $t("PleaseEnterDescription") }}."</span
        >
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="showError"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";

export default {
  name: "Content_management_Forums_Pending_AnswerPopup",
  props: {
    show: { default: false },
    userInfoCurrent: "",
    ParentIdCurrent: "",
    productInfoIdCurrent: {},
    persianProductName: "",
    lastAnswer: ""
  },
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      disabled: true,
      model: {},
      showError: true,
      modelName: ""
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  beforeUpdate() {
    if (this.lastAnswer != "") {
      this.showError = false;
    }
  },
  methods: {
    ...mapActions({
      ConfirmAnswer: "SalesPartnerPlan/ConfirmAnswer"
    }),
    submitForm() {
      this.model.userInfo = this.userInfoCurrent;
      this.model.parent = this.ParentIdCurrent;
      this.model.productId = this.productInfoIdCurrent;
      this.model.description =
        this.lastAnswer != "" ? this.lastAnswer : this.modelName;
      this.model.persianProductName = this.persianProductName;
      if (this.model.description != "") {
        this.ConfirmAnswer(this.model).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "توضیحات مورد نظر با موفقیت ثبت شد!",
            showConfirmButton: false,
            timer: 2000
          });

          this.$emit("finish");
        });
      } else {
        this.showError = false;
      }
    }
  },
  watch: {
    modelName(newValue) {
      if (newValue != "" || this.lastAnswer != "") {
        this.showError = false;
      } else {
        this.showError = true;
      }
    }
  }
};
</script>
